var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns mt-6"},[_c('div',{staticClass:"column",class:{'offset-menu': _vm.menuOpen}},[_c('div',{staticClass:"container"},[_c('highcharts',{attrs:{"options":_vm.pieData}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }